/*import React, { useRef, useState } from "react";
import JoditEditor from "jodit-react";
import "./Blogpost.css";

const Blogpost = ({ categories }) => {
    const editor = useRef(null);
    const [post, setPost] = useState({ title: "", content: "", categoryId: 0 });
    const [image, setImage] = useState(null);

    const fieldChanged = (event) => {
        setPost({ ...post, [event.target.name]: event.target.value });
        console.log(event.target.value)
    };

    const contentFieldChanged = (newContent) => {
        setPost({ ...post, content: newContent });
    };

    const handleFileChange = (event) => {
        setImage(event.target.files[0]);
    };

    const createPost = (event) => {
        event.preventDefault();
        console.log("Post Submitted", post, image);
    };

    return (
        <div className="wrapper">
            <div className="card">
                <div className="card-body">
                
                    <h3>What’s going on in your mind?</h3>
                    <form onSubmit={createPost}>
                        <div className="form-group">
                            <label htmlFor="title">Post Title</label>
                            <input
                                type="text"
                                id="title"
                                name="title"
                                placeholder="Enter here"
                                onChange={fieldChanged}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="content">Post Content</label>
                            <JoditEditor ref={editor} value={post.content} onChange={contentFieldChanged} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="image">Select Post Banner</label>
                            <input type="file" id="image" onChange={handleFileChange} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="category">Post Category</label>
                            <input type="text"
                             id="category"
                              name="category"
                               placeholder="Enter here"
                                onChange={fieldChanged} 
                                 />
                        </div>
                        <div className="button-container">
                            <button type="submit" className="primary-btn">Create Post</button>
                            <button type="reset" className="danger-btn">Reset Content</button>
                        </div>
                    </form>
                </div>
            </div>
            </div>
  );
}
export default Blogpost;
*/
/*import React, { useRef, useState } from "react";
import JoditEditor from "jodit-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Blogpost.css";

const Blogpost = ({ categories }) => {
    const editor = useRef(null);
    const navigate = useNavigate();
    const [post, setPost] = useState({ title: "", content: "", category: 0 });
    const [image, setImage] = useState(null);

    const fieldChanged = (event) => {
        const { name, value } = event.target;
        setPost({ ...post, [name]: value });
    };

    const contentFieldChanged = (newContent) => {
        setPost({ ...post, content: newContent });
    };

    const handleFileChange = (event) => {
        setImage(event.target.files[0]);
    };

    const createPost = async (event) => {
        event.preventDefault();
    
        // Convert image to base64
        let base64Image = "";
        if (image) {
            base64Image = await toBase64(image);
        }
    
        const payload = {
            title: post.title,
            content: post.content,
            category: post.category.toString(), // convert number to string if needed
            image: base64Image
        };

        console.log("Payload being sent to API:", payload);
    
        try {
            const response = await axios.post("https://baseapis.akari.sa/api/Blog/AddBlog", payload, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            console.log("Post created successfully:", response.data);
             navigate("/blog");
        } catch (error) {
            console.error("Error creating post:", error);
        }
    };
    
    // Helper: Convert image file to base64
       const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const result = reader.result;
                const base64 = result.split(',')[1]; // Strip prefix
                resolve(base64);
            };
            reader.onerror = (error) => reject(error);
        });



    return (
        /*<div className="wrapper">
            <div className="card">
                <div className="card-body">
                    <h3>What’s going on in your mind?</h3>
                    <form onSubmit={createPost}>
                        <div className="form-group">
                            <label htmlFor="title">Post Title</label>
                            <input
                                type="text"
                                id="title"
                                name="title"
                                placeholder="Enter here"
                                onChange={fieldChanged}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="content">Post Content</label>
                            <JoditEditor ref={editor} value={post.content} onChange={contentFieldChanged} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="image">Select Post Banner</label>
                            <input type="file" id="image" onChange={handleFileChange} />
                        </div>
                        <div className="form-group">
                             <label htmlFor="date">Post Date</label>
                             <input type="text" id="date"
                                name="category"
                                placeholder="Enter category ID"
                                onChange={fieldChanged}
                            />
                        </div>
                        <div className="button-container">
                            <button type="submit" className="primary-btn">Create Post</button>
                            <button type="reset" className="danger-btn">Reset Content</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    );
};

export default Blogpost;
*/
import React, { useRef, useState } from "react";
import JoditEditor from "jodit-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Blogpost.css";

const Blogpost = ({ categories }) => {
    const editor = useRef(null);
    const navigate = useNavigate();
    const [post, setPost] = useState({ title: "", content: "", category: "", postDate: "" });
    const [image, setImage] = useState(null);

    const fieldChanged = (event) => {
        const { name, value } = event.target;
        setPost({ ...post, [name]: value });
    };

    const contentFieldChanged = (newContent) => {
        setPost({ ...post, content: newContent });
    };

    const handleFileChange = (event) => {
        setImage(event.target.files[0]);
    };

    // Helper function to convert image to base64
    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const createPost = async (event) => {
        event.preventDefault();

        // Convert image to base64 if there is an image
        let base64Image = "";
        if (image) {
            base64Image = await toBase64(image);
        }

        // Prepare payload with BlogDto object
        const payload = {
            id: 0,  // Assuming you want to create a new post
            title: post.title,
            content: post.content,
            category: post.category,
            image: base64Image ? [base64Image] : [],  // Wrap image in array
        };

        console.log("Payload being sent to API:", payload);

        try {
            const response = await axios.post(
                "https://baseapis.akari.sa/api/Blog/AddBlog",
                payload,
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            );
            console.log("Post created successfully:", response.data);
            navigate("/blog");
        } catch (error) {
            console.error("Error creating post:", error);
            if (error.response) {
                console.error("API error response:", error.response.data);
                console.error("Error status:", error.response.status);
            } else {
                console.error("Error message:", error.message);
            }
        }
    };

    return (
        <div className="wrapper">
            <div className="card">
                <div className="card-body">
                    <h3>What’s going on in your mind?</h3>
                    <form onSubmit={createPost}>
                        <div className="form-group">
                            <label htmlFor="title">Post Title</label>
                            <input
                                type="text"
                                id="title"
                                name="title"
                                placeholder="Enter here"
                                onChange={fieldChanged}
                                value={post.title}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="content">Post Content</label>
                            <JoditEditor
                                ref={editor}
                                value={post.content}
                                onChange={contentFieldChanged}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="image">Select Post Banner</label>
                            <input type="file" id="image" onChange={handleFileChange} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="category">Category</label>
                            <select
                                id="category"
                                name="category"
                                onChange={fieldChanged}
                                value={post.category}
                            >
                                {categories && categories.length > 0 ? (
                                    categories.map((category, index) => (
                                        <option key={index} value={category}>
                                            {category}
                                        </option>
                                    ))
                                ) : (
                                    <option value="">No Categories Available</option>
                                )}
                            </select>
                        </div>
                        <div className="button-container">
                            <button type="submit" className="primary-btn">
                                Create Post
                            </button>
                            <button type="reset" className="danger-btn">
                                Reset Content
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Blogpost;
